import { render } from "./UpIcon.vue?vue&type=template&id=ca448ae0&ts=true"
import script from "./UpIcon.vue?vue&type=script&lang=ts"
export * from "./UpIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__